module.exports = __webpack_public_path__ + "img/107146162.46d85738.jpg";